import { NavigateFunction } from 'react-router-dom';
import { PasswordResetError } from '../../../../errors/passwordResetError';
import {
	ActionTypeNames,
	ActionValues,
	createActionCreators,
} from '../../../../store/actions';
import { ThunkAction } from '../../../../store/middleware';

export const passwordResetActions = createActionCreators<
	{ T: 'RESET_PASSWORD_REQUEST'; P: string },
	{ T: 'RESET_PASSWORD_RECEIVE' },
	{ T: 'RESET_PASSWORD_FAILURE'; P: { error: PasswordResetError } }
>('RESET_PASSWORD_REQUEST', 'RESET_PASSWORD_RECEIVE', 'RESET_PASSWORD_FAILURE');

export const passwordResetConfirmActions = createActionCreators<
	{
		T: 'PASSWORD_RESET_CONFIRM_REQUEST';
		P: { email: string; code: string; password: string };
	},
	{ T: 'PASSWORD_RESET_CONFIRM_RECEIVE' },
	{ T: 'PASSWORD_RESET_CONFIRM_FAILURE'; P: { error: PasswordResetError } }
>(
	'PASSWORD_RESET_CONFIRM_REQUEST',
	'PASSWORD_RESET_CONFIRM_RECEIVE',
	'PASSWORD_RESET_CONFIRM_FAILURE'
);

export const passwordResetConfirmPassword =
	(
		email: string,
		code: string,
		password: string,
		navigate: NavigateFunction
	): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(
			passwordResetConfirmActions.PASSWORD_RESET_CONFIRM_REQUEST({
				email,
				code,
				password,
			})
		);
		try {
			await api.authentication.confirmPasswordReset(
				email,
				code,
				password
			);
			dispatch(
				passwordResetConfirmActions.PASSWORD_RESET_CONFIRM_RECEIVE()
			);
			navigate('/reset-success');
		} catch (error) {
			dispatch(
				passwordResetConfirmActions.PASSWORD_RESET_CONFIRM_FAILURE({
					error,
				})
			);
			throw error;
		}
	};

export const requestPasswordReset =
	(email: string, navigate: NavigateFunction): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(passwordResetActions.RESET_PASSWORD_REQUEST(email));
		try {
			await api.authentication.requestPasswordReset(email);
			dispatch(passwordResetActions.RESET_PASSWORD_RECEIVE());
			navigate('/reset-new');
		} catch (error) {
			dispatch(passwordResetActions.RESET_PASSWORD_FAILURE({ error }));
			throw error;
		}
	};

const actions = { ...passwordResetConfirmActions, ...passwordResetActions };

type PasswordResetActions = ActionValues<typeof actions>;
type PasswordResetActionsTypes = ActionTypeNames<PasswordResetActions>;
export type Actions = PasswordResetActions[keyof PasswordResetActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as PasswordResetActionsTypes);
